import { render, staticRenderFns } from "./ChangeServicePackage.vue?vue&type=template&id=23e81729&"
import script from "@/scripts/modal/rentalService/changeServicePackage.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/rentalService/changeServicePackage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports